export const locales = ['GB', 'SE'];